<template>
  <div>
    <div class="page-title">Edit Support Form</div>
    <Form v-if="form" btnText="Update Form" :submit="update" v-model="form" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.support.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.SupportForm.update(this.form);
      this.$router.push("/support");
    },
    async setForm() {
      const { data } = await this.$api.SupportForm.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
